import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const EllipsisHorizontalIcon = createIcon({
  displayName: 'EllipsisHorizontalIcon',
  path: (
    <>
      <path stroke='none' d='M0 0h24v24H0z' />
      <path d='M4 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0m7 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0m7 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0' />
    </>
  ),
  defaultProps: {
    ...defaultProps,
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }
})
